// Cluase  GET endpoint
export const getClauseListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
   return `condition_clause${queryString ? `?${queryString}` : ""}`;
};


//Cluase POST new Clause
export const addClauseApi = () => {
    return `/condition_clause`;
};

//  Cluase PUT edit Clause
export const  updateClauseApi = (params) => {
    return `/condition_clause/${params?.asset_slug}/`;
};

// Cluase DELETE Clause
export const  deleteClauseApi = (params) => {
    return `condition_clause`;
};


